import { Component, OnInit } from '@angular/core';
import { TranslationService } from '@spartacus/core';
import { CommonPageBreadcrumbsComponent } from '../../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';

@Component({
    selector: 'app-login-breadcrumb',
    templateUrl: './login-breadcrumb.component.html',
    styleUrls: ['./login-breadcrumb.component.scss'],
    imports: [CommonPageBreadcrumbsComponent]
})
export class LoginBreadcrumbComponent implements OnInit {
  title = 'Log In';
  navigationData = 'Digital Gateway';
  constructor(private translation: TranslationService) { }

  ngOnInit(): void {
    this.translation.translate('breadcrumb.login.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.login.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
  }

}
